<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      :readonly="item.locked"
      :labelAlign="$config.forms.defaultLabelAlign"
      autofocus="first"
      @submit="evh_8564662037462133_submit($event, {})"
    >
      <ItpRow>
        <ItpCol
          w="12"
        >
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="5"
            name="name"
            :label="'Name'|pgettext('Register')"
            required
          >
            <ItpFormInput
              name="name"
              v-model="editor.name"
              required
              :placeholder="'The name of the register.'|pgettext('Register')"
              autofocus
            >
            </ItpFormInput>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="5"
            name="company"
            :label="'Company'|pgettext('Register')"
            required
          >
            <ItpFormSelect2
              name="company"
              v-model="editor.company"
              :dataSource="b_6126985650642047_dataSource"
              prefetch
              bind-object
              textField="name"
              required
            >
            </ItpFormSelect2>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="5"
            name="notes"
            :label="'Notes'|pgettext('Register')"
            :labelAlign="labelAlign"
          >
            <ItpFormTextarea
              name="notes"
              v-model="editor.notes"
            >
            </ItpFormTextarea>
          </ItpFormGroup>
          <ItpFormGroup
            labelColsMd="3"
            contentColsMd="9"
          >
            <ItpButton
              type="submit"
              :text="item.isNew ? messages.submitNewItem : messages.saveItem"
              :form="formId"
              :spinning="actions.save.isRunning"
            >
            </ItpButton>
            <ItpButton
              :text="'Delete'|pgettext('Register')"
              variant="danger"
              v-if="!item.isNew"
              @click.prevent.stop="evh_655921014111650_clickPreventStop($event, {})"
            >
            </ItpButton>
            <ItpButton
              :text="'Cancel'|pgettext('Register')"
              variant="default"
              @click.prevent.stop="evh_1238468668488283_clickPreventStop($event, {})"
            >
            </ItpButton>
          </ItpFormGroup>
        </ItpCol>
      </ItpRow>
    </ItpForm>
    <HR>
    </HR>
    <UcRegisterVersions
      :register="item"
      :reload="lastLoaded"
      v-if="!item.isNew"
      @reload="evh_1889980785424776_reload($event, {})"
    >
    </UcRegisterVersions>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcRegister extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const [editor] = args

    if (editor.isNew) {
      console.log(editor.getChanges({ skipEmbeddedLists: true }))
      return editor.getChanges({ skipEmbeddedLists: true });
    }

    return {
      id: editor.id,
      etag: editor.getETAG(),
      ...editor.getChanges({ skipEmbeddedLists: true })
    };
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  messages!: any;
  formName!: any;
  labelAlign!: any;

  async $$load_labelAlign() {
    return this.$config.forms.defaultLabelAlign
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  item!: any;

  async $$load_item() {
    return this.oid
      ? this.$fn.fetch('read_register', { asResource: true, parameters: { id: this.oid } })
      : this.$fn.schemaDefaults('CreateRegister')
  }

  editor!: any;

  async $$load_editor() {
    return this.item.editor()
  }

  ux!: any;
  b_6126985650642047_dataSource!: any;
  dataMembers = ['messages', 'formName', 'labelAlign', 'formId', 'item', 'editor', 'ux', 'b_6126985650642047_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          submitNewItem: this.$fn.pgettext("Register|Command", "Create register"),
          saveItem: this.$fn.pgettext("Register|Command", "Save changes"),
        }
        ,
        formName: "register",
        labelAlign: null,
        formId: null,
        item: null,
        editor: null,
        ux: null,
        b_6126985650642047_dataSource: {
          name: "suggest_company",
          parameters: {
            role: "own",
          }
          ,
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_emit_7976_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_8564662037462133_emit_7976, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async act_8564662037462133_crud_7974_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_8564662037462133_crud_7974, alias=save
    return {
      objectType: "register",
      op: "upsert",
      data: this.getPayload(this.editor),
    }
  }

  async evh_8564662037462133_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_submit.executeFromDOM(this, event, scope);
  }

  async act_655921014111650_emit_7980_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_655921014111650_emit_7980, alias=undefined
    return {
      event: "deleted",
      value: this.editor,
    }
  }

  async act_655921014111650_crud_7978_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_655921014111650_crud_7978, alias=delete
    return {
      objectType: "register",
      op: "delete",
      data: this.getPayload(this.editor),
    }
  }

  async act_655921014111650_crud_7978_getConfirm($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_655921014111650_crud_7978, alias=delete
    return {
      header: this.$fn.pgettext("Register|Header", "Please confirm deleting this register."),
      message: this.$fn.pgettext("Register", "This action cannot be undone."),
      btnOk: this.$fn.gettext("Delete"),
    }
  }

  async evh_655921014111650_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_655921014111650_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1238468668488283_emit_7982_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_1238468668488283_emit_7982, alias=undefined
    return {
      event: "deleted",
      value: {},
    }
  }

  async evh_1238468668488283_clickPreventStop_7981_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1238468668488283_clickPreventStop_7981, alias=undefined
    return this.item.isNew
  }

  async evh_1238468668488283_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1238468668488283_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_1889980785424776_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1889980785424776_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_7972: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_7971: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_8564662037462133_emit_7976: actions.EmitAction;
    evh_8564662037462133_success_7975: actions.EventHandlerImpl;
    act_8564662037462133_crud_7974: actions.CRUDAction;
    evh_8564662037462133_submit_7973: actions.EventHandlerImpl;
    evh_8564662037462133_submit: actions.EventHandlerGroup;
    act_655921014111650_emit_7980: actions.EmitAction;
    evh_655921014111650_success_7979: actions.EventHandlerImpl;
    act_655921014111650_crud_7978: actions.CRUDAction;
    evh_655921014111650_clickPreventStop_7977: actions.EventHandlerImpl;
    evh_655921014111650_clickPreventStop: actions.EventHandlerGroup;
    act_1238468668488283_emit_7982: actions.EmitAction;
    evh_1238468668488283_clickPreventStop_7981: actions.EventHandlerImpl;
    evh_1238468668488283_clickPreventStop: actions.EventHandlerGroup;
    act_1889980785424776_reloadComponentData_7984: actions.ReloadComponentDataAction;
    evh_1889980785424776_reload_7983: actions.EventHandlerImpl;
    evh_1889980785424776_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_7972 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_7971 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_7972,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_7971],
      }
    );
    const act_8564662037462133_emit_7976 = new actions.EmitAction(
      {
        actionArgs: this.act_8564662037462133_emit_7976_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_success_7975 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_emit_7976,
        event: "success",
        displayName: "emit",
      }
    );
    const act_8564662037462133_crud_7974 = new actions.CRUDAction(
      {
        actionArgs: this.act_8564662037462133_crud_7974_getActionArgs,
        displayName: "save",
        events: [evh_8564662037462133_success_7975],
      }
    );
    const evh_8564662037462133_submit_7973 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_crud_7974,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_8564662037462133_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_submit_7973],
      }
    );
    const act_655921014111650_emit_7980 = new actions.EmitAction(
      {
        actionArgs: this.act_655921014111650_emit_7980_getActionArgs,
        events: [],
      }
    );
    const evh_655921014111650_success_7979 = new actions.EventHandlerImpl(
      {
        action: act_655921014111650_emit_7980,
        event: "success",
        displayName: "emit",
      }
    );
    const act_655921014111650_crud_7978 = new actions.CRUDAction(
      {
        actionArgs: this.act_655921014111650_crud_7978_getActionArgs,
        confirm: this.act_655921014111650_crud_7978_getConfirm,
        displayName: "delete",
        events: [evh_655921014111650_success_7979],
      }
    );
    const evh_655921014111650_clickPreventStop_7977 = new actions.EventHandlerImpl(
      {
        action: act_655921014111650_crud_7978,
        event: "click.prevent.stop",
        displayName: "delete",
      }
    );
    const evh_655921014111650_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_655921014111650_clickPreventStop_7977],
      }
    );
    const act_1238468668488283_emit_7982 = new actions.EmitAction(
      {
        actionArgs: this.act_1238468668488283_emit_7982_getActionArgs,
        events: [],
      }
    );
    const evh_1238468668488283_clickPreventStop_7981 = new actions.EventHandlerImpl(
      {
        action: act_1238468668488283_emit_7982,
        event: "click.prevent.stop",
        when: this.evh_1238468668488283_clickPreventStop_7981_getWhen,
        displayName: "emit",
      }
    );
    const evh_1238468668488283_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1238468668488283_clickPreventStop_7981],
      }
    );
    const act_1889980785424776_reloadComponentData_7984 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_1889980785424776_reload_7983 = new actions.EventHandlerImpl(
      {
        action: act_1889980785424776_reloadComponentData_7984,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_1889980785424776_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_1889980785424776_reload_7983],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_7972,
      evh_7315092382398562_reload_7971,
      evh_7315092382398562_reload,
      act_8564662037462133_emit_7976,
      evh_8564662037462133_success_7975,
      act_8564662037462133_crud_7974,
      evh_8564662037462133_submit_7973,
      evh_8564662037462133_submit,
      act_655921014111650_emit_7980,
      evh_655921014111650_success_7979,
      act_655921014111650_crud_7978,
      evh_655921014111650_clickPreventStop_7977,
      evh_655921014111650_clickPreventStop,
      act_1238468668488283_emit_7982,
      evh_1238468668488283_clickPreventStop_7981,
      evh_1238468668488283_clickPreventStop,
      act_1889980785424776_reloadComponentData_7984,
      evh_1889980785424776_reload_7983,
      evh_1889980785424776_reload,
      save: act_8564662037462133_crud_7974,
      delete: act_655921014111650_crud_7978,
    }
  }
}

Vue.component("UcRegister", UcRegister);

</script>